import http from '@/http'

export default {
  url: '/api/auth',

  login(credentials) {
    return http.post(this.url + '/login', credentials)
  },

  forgotPassword(email) {
    return http.post(this.url + '/password/email', { email })
  },

  resetPassword(credentials) {
    return http.post(this.url + '/password/reset', credentials)
  },

  signup(data) {
    return http.post(this.url + '/register', data)
  },

  refresh() {
    return http.post(this.url + '/refresh')
  },

  user() {
    return http.get('/api/user')
  }
}
